export const subscriptionStatus = {
    Active: 1,
    Inactive: 2,
    Expired: 3
}